import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { LightUser, User } from 'types/user';
import { actionCreatorFactory } from 'typescript-fsa';

export const usersXhrModule = createXhrStatusModule('users');
const actionCreator = actionCreatorFactory('timely/users');

export const fetched = actionCreator<Array<User>>('FETCHED');
export const fetchedPartial = actionCreator<Array<User>>('FETCHED_PARTIAL');
export const addUser = actionCreator<User>('ADD_USER');
export const removeUser = actionCreator<number>('REMOVE_USER');
export const updateUser = actionCreator<User>('UPDATE_USER');

export const fetchedSearchResults = actionCreator<Array<LightUser>>('FETCHED_SEARCH_RESULTS');
export const clearSearchResults = actionCreator('CLEAR_SEARCH_RESULTS');

export interface State {
  entries: Array<User>;
  xhrStatus: XhrStatus;
  searchResults: Array<LightUser>;
}
